export const NEW_DATA_EVENT = "NEW_DATA_EVENT";
export const PAUSE_TIMER_EVENT = "PAUSE_TIMER_EVENT"
export const RESUME_TIMER_EVENT = "RESUME_TIMER_EVENT"
